module.exports = __webpack_public_path__ + "img/icon_5_23.2be2096c.png";